export { Switch, switchRootVariants } from './Switch'
export type { SwitchProps } from './Switch'
